import React, { useEffect, useRef } from "react";
import styles from "./HomePoster.scss";

import left from "../../../assets/homePoster/leftBar.png";
import right from "../../../assets/homePoster/rightBar.png";
import main from "../../../assets/homePoster/topMask.png";
import { useNavigate } from "react-router-dom";
import { HashLink } from "react-router-hash-link";
import NeedExpertPopup from "../Popup/NeedExpertPopup";

const HomePoster = () => {
    const [modalIsOpen, setModalIsOpen] = React.useState(false);
    const closeModal = () => setModalIsOpen(false);

    const imagesRef = useRef([]);
    const textRef = useRef([]);
    const navigate = useNavigate();
    useEffect(() => {
        // Function to add the 'active' class to each image with a delay
        const addActiveClassWithDelay = () => {
            imagesRef.current.forEach((image, index) => {
                setTimeout(() => {
                    if (image) {
                        image.classList.add("active");
                    }
                }, index * 1000); // Delay for each image by index * 1000 ms
            });
            textRef.current.forEach((text, index) => {
                setTimeout(() => {
                    if (text) {
                        text.classList.add("active");
                    }
                }, index * 500); // Delay for each image by index * 1000 ms
            });
        };

        addActiveClassWithDelay();
    }, []);
    return (
        <>
            <div className="expert-insights container md:min-h-[100vh]">


                <div className="text-section flex flex-col w-full">
                    <div className="image-section">
                        <div className="image-stack transform">
                            <img
                                src={left}
                                alt="Image 1"
                                className="stacked-image"
                                ref={(el) => (imagesRef.current[0] = el)}
                            />
                            <img
                                src={main}
                                alt="Image 2"
                                className="stacked-image"
                                ref={(el) => (imagesRef.current[1] = el)}
                            />
                            <img
                                src={right}
                                alt="Image 3"
                                className="stacked-image"
                                ref={(el) => (imagesRef.current[2] = el)}
                            />
                        </div>
                    </div>
                    <div className="font-medium light-title capitalize text-show">
                        <span
                            className="text-3xl sm:text-5xl pr-2 light-title font-light fading mx-auto max-sm:w-[300px]"
                            ref={(el) => (textRef.current[0] = el)}
                        >
                            Your
                        </span>{" "}
                        <br className="hidden sm:block" />
                        <span
                            className="text-3xl sm:text-7xl pr-2  text-color fading mx-auto max-sm:w-[300px]"
                            ref={(el) => (textRef.current[1] = el)}
                        >
                            Trusted
                        </span>
                        <br className="hidden sm:block" />
                        <span
                            className="text-3xl sm:text-5xl pr-2 font-light light-title leading-[56px] fading mx-auto max-sm:w-[300px]"
                            ref={(el) => (textRef.current[2] = el)}
                        >
                            Partner{" "}
                        </span>
                        <span
                            className="text-3xl sm:text-4xl font-light pr-2 light-title lowercase leading-[56px] fading mx-auto max-sm:w-[300px]"
                            ref={(el) => (textRef.current[3] = el)}
                        >
                            for
                        </span>
                        <br className="hidden sm:block" />
                        <span
                            className="text-3xl sm:text-7xl text-color pr-2 uppercase fading mx-auto max-sm:w-[300px]"
                            ref={(el) => (textRef.current[4] = el)}
                        >
                            Expert
                        </span>
                        <br className="hidden sm:block" />
                        <span
                            className="text-3xl sm:text-5xl font-light light-title leading-[54px] fading mx-auto max-sm:w-[300px]"
                            ref={(el) => (textRef.current[5] = el)}
                        >
                            Insights
                        </span>
                        <br className="hidden sm:block" />
                        <span
                            className="text-3xl sm:text-[21px] text-left font-[400] fading below-text text-color mt-4 banner-text"
                            ref={(el) => (textRef.current[6] = el)}
                        >
                            Connecting consultants and businesses with industry leaders for
                            valuable market insights.
                        </span>
                        <div
                            className="buttons fading flex mt-lg-12 mt-auto"
                            ref={(el) => (textRef.current[7] = el)}
                        >
                            <button
                                className="need-expert text-sm sm:text-[22px] font-normal dark-button h-14 shadow-xl rounded-lg"
                                onClick={() => (window.location.href = "/expert-form")}
                            >
                                Need An Expert
                            </button>
                            <button className="become-expert text-sm sm:text-[22px] font-normal h-14 shadow-xl rounded-lg">
                                <HashLink smooth
                                    to="/experts#become-expert-form"
                                    scroll={(el) => {
                                        const offset = -80; // Adjust for header height or additional spacing
                                        const y = el.getBoundingClientRect().top + window.scrollY + offset;
                                        window.scrollTo({ top: y, behavior: 'smooth' });
                                    }}
                                >
                                    Become An Expert
                                </HashLink>
                            </button>
                        </div>
                    </div>
                </div>
            </div>
            <NeedExpertPopup isOpen={modalIsOpen} closeModal={closeModal} />
        </>
    );
};

export default HomePoster;
